import React, { useContext, useEffect, useState } from "react";
import {
  Mail,
  PhoneCall,
  Star,
  MoreVertical,
  CheckCircle2,
  ShieldX,
  Building2,
  Copy,
  XCircle,
  MapPin,
  Pencil,
  Lock,
  Check,
  X,
  Calendar,
  Clock,
  User,
  Plus,
  Info,
  CopyCheck,
  SquarePen,
  Trophy,
  MessageSquare,
  ThumbsUp,
  ThumbsDown,
  FileText,
} from "lucide-react";
import { Link, useParams } from "react-router";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { GlobalContext } from "../../../../context/Context";
import moment from "moment/moment";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import Tooltip from "../../../../component/ui/tooltip";
import CommentsSection from "../../../../component/comment";
// import AddActivityModal from "../../../activities/activity/add-update/add-update-activity";
import FilesTab from "../../../../component/files";
import Style from "./style.module.css";
import Chip from "../../../../component/ui/chip";
import Swal from "sweetalert2";
// import WonDeal from "../../../deals/deal/won-deal/won-form-deal";
// import LostDeal from "../../../deals/deal/lost-deal/lost-form-deal";
import InvoiceQuickView from "../../../../component/invoice/InvoiceQuickView";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import WonDeal from "../../../mainDeals/deals/deal/won-deal/won-form-deal";
import LostDeal from "../../../mainDeals/deals/deal/lost-deal/lost-form-deal";
// import UpdateLeadDetails from "./add-update/update-leadDetails";

const IconButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex h-10 w-10 items-center justify-center rounded-xl border border-solid border-slate-200 bg-white/90 text-slate-600 backdrop-blur transition hover:border-slate-300 hover:bg-white hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 ${className}`}
    {...props}
  >
    {children}
  </button>
);

// const SectionCard = ({ title, right, children }) => (
//   <section className="rounded-2xl border border-solid border-slate-200 bg-white shadow-sm">
//     <header className="flex items-center justify-between px-5 py-4">
//       <h3 className="text-sm font-semibold tracking-tight text-slate-800">{title}</h3>
//       {right}
//     </header>
//     <div className="px-5 pb-5">{children}</div>
//   </section>
// );

const SectionCard = ({ title, right, children }) => (
  <section className="rounded-[12px] bg-white p-[25px]">
    <header className="flex items-center justify-between pb-[20px]">
      <h3 className="text-[20px] font-medium tracking-tight text-[#0E121B]">
        {title}
      </h3>
      {right}
    </header>
    <div className="">{children}</div>
  </section>
);

const InfoItem = ({ icon, label, value, action }) => (
  <div className="group flex items-center gap-4 rounded-xl border border-solid border-slate-200 bg-white p-4 shadow-sm transition hover:shadow">
    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-50 text-slate-600">
      {icon}
    </div>
    <div className="min-w-0 flex-1">
      <div className="text-xs text-slate-500">{label}</div>
      <div className="truncate text-sm font-medium text-slate-900">
        {value || "—"}
      </div>
    </div>
    {action && (
      <div className="opacity-0 transition group-hover:opacity-100">
        {action}
      </div>
    )}
  </div>
);

const LeadTabs = ({
  leadDetail,
  isLoading,
  editableFields = {},
  onFieldSave,
  DealStages,
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  PackageList = [],
  UsersList = [],
  entityData = [],
  onSearchEntity,
}) => {
  const [activeTab, setActiveTab] = useState("info");
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const campaignKeys = [
    "parent_url",
    "user_agent",
    "campaigned",
    "is_dropoff",
    "adgroupid",
    "keyword",
    "device",
    "matchtype",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ];

  const excludeKeys = [
    "name",
    "email",
    "phone",
    "lead_source",
    "leadstatus",
    "leadtime",
    "country",
    "date",
  ];

  const campaignMeta = leadDetail?.metas?.filter((m) =>
    campaignKeys.includes(m.meta_key)
  );

  const otherMeta = leadDetail?.metas?.filter(
    (m) =>
      !campaignKeys.includes(m.meta_key) && !excludeKeys.includes(m.meta_key)
  );

  return (
    <div className="mt-6">
      {/* Tabs */}
      <div className="flex border-b border-gray-200 mb-4">
        {[
          "info",
          "stages",
          "follow-ups",
          "timeline",
          "comments",
          "files",
          "brief",
        ].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium ${
              activeTab === tab
                ? "border-b-2 border-blue-500 text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="h-[calc(100vh-647px)] overflow-y-auto pb-1">
        {activeTab === "info" && (
          <div className="space-y-6">
            {/* Client / Lead / Brand Info Cards */}
            <SectionCard title="About">
              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <FieldRow label="Deal Name" value={leadDetail?.name || "-"} />

                  <FieldRow
                    label="Deal Product"
                    value={leadDetail?.deal_product_name || "-"}
                  />
                </div>
                <div>
                  <FieldRow
                    label="Deal Package"
                    value={leadDetail?.deal_package_name || "-"}
                  />
                  <FieldRow
                    label="Deal Time"
                    value={leadDetail?.dealtime || "-"}
                  />
                </div>

                <div>
                  <FieldRow label="Deal Id" value={leadDetail?.dealid || "-"} />
                </div>
                <div>
                  <FieldRow
                    label="Deal Key"
                    value={leadDetail?.dealkey || "-"}
                  />
                </div>
              </div>
            </SectionCard>

            <SectionCard title="Made By">
              <div className="flex items-center gap-4">
                {leadDetail?.made_by?.userimg ? (
                  <img
                    src={leadDetail.made_by.userimg}
                    alt={leadDetail?.made_by?.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none"; // hide broken image
                      e.target.nextSibling.style.display = "flex"; // show fallback
                    }}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : null}

                {/* Fallback avatar (hidden by default if image exists) */}
                <div
                  style={{
                    display: leadDetail?.made_by?.userimg ? "none" : "flex",
                  }}
                  className="w-10 h-10 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center font-semibold text-sm uppercase"
                >
                  {leadDetail?.made_by?.name?.[0] || "-"}
                </div>

                <div className="flex flex-col">
                  <span className="font-medium text-sm">
                    {leadDetail?.made_by?.name || "-"}
                  </span>
                  <a
                    href={`mailto:${leadDetail?.made_by?.email}`}
                    className="text-xs text-gray-500 hover:underline"
                  >
                    {leadDetail?.made_by?.email || "-"}
                  </a>
                </div>
              </div>
            </SectionCard>

            <SectionCard title="Deal Detail">
              <div className="grid gap-6 md:grid-cols-2">
                {leadDetail?.stats?.length > 0 ? (
                  leadDetail.stats.map((item, i) => (
                    <FieldRow
                      key={i}
                      label={item.key.replaceAll("_", " ")} // Convert deal_amount → Deal Amount
                      value={item.value || "-"}
                    />
                  ))
                ) : (
                  <p className="text-gray-500 text-sm col-span-2">
                    No deal details available.
                  </p>
                )}
              </div>
            </SectionCard>

            {campaignMeta?.length > 0 && (
              <SectionCard title="Campaign Details">
                <div className="grid gap-2 grid-cols-2">
                  {campaignMeta.map((st, i) => (
                    <FieldRow
                      key={i}
                      label={st.meta_key
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                      value={st.meta_value || "-"}
                    />
                  ))}
                </div>
              </SectionCard>
            )}

            {otherMeta?.length > 0 && (
              <SectionCard title="Additional Details">
                <div className="grid gap-2 grid-cols-2">
                  {otherMeta.map((st, i) => (
                    <FieldRow
                      key={i}
                      label={st.meta_key
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                      value={st.meta_value || "-"}
                    />
                  ))}
                </div>
              </SectionCard>
            )}
          </div>
        )}

        {activeTab === "stages" && leadDetail?.stages?.length > 0 && (
          <div className="">
            <div className="relative border-l-2 border-slate-200 pl-4 ml-1 space-y-5">
              {leadDetail.stages.map((stage, index) => {
                const isLast = index === leadDetail.stages.length - 1;

                // Color map
                const statusColors = {
                  "Need Analysis": "bg-yellow-500",
                  "Value Proposition": "bg-blue-500",
                  "Identify Decision": "bg-violet-500",
                  Proposal: "bg-teal-500",
                  Review: "bg-indigo-500",
                  Won: "bg-green-500",
                  Lost: "bg-rose-500",
                };

                const colorClass =
                  statusColors[stage?.dealstatus] || "bg-gray-400";

                return (
                  <div
                    key={stage?.dealstatuslogid || index}
                    className="relative pl-6"
                  >
                    {/* Dot */}
                    <span
                      className={`absolute left-[-11px] top-1 w-3 h-3 rounded-full border-2 border-white shadow ${colorClass}`}
                    ></span>

                    {/* Content */}
                    <div className="flex flex-col">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span
                            className={`text-sm font-semibold ${colorClass.replace(
                              "bg-",
                              "text-"
                            )}`}
                          >
                            {stage?.dealstatus}
                          </span>
                          <span className="text-xs text-slate-400">
                            (by {stage?.user?.name || "System"})
                          </span>
                        </div>
                        <span className="text-xs text-slate-400">
                          {stage?.logtime
                            ? moment(stage?.logtime).fromNow()
                            : "-"}
                        </span>
                      </div>

                      <div className="text-xs text-slate-500 mt-1">
                        Updated at:{" "}
                        {stage?.logtime
                          ? moment(stage?.logtime).format(
                              "DD-MMM-YYYY, hh:mm A"
                            )
                          : "-"}
                      </div>
                    </div>

                    {/* Connector Line */}
                    {!isLast && (
                      <span className="absolute left-[-3px] top-5 w-[2px] h-full bg-slate-200"></span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {activeTab === "follow-ups" && (
          <div className="space-y-4">
            {/* ✅ Activity Cards */}
            {leadDetail?.schedules?.length ? (
              <div className="space-y-3">
                {leadDetail.schedules.map((sch, i) => {
                  const isCompleted = sch.status?.toLowerCase() === "completed";
                  const isPending = sch.status?.toLowerCase() === "pending";
                  const isHigh = sch.priority?.toLowerCase() === "high";

                  const typeColors = {
                    meeting: "bg-blue-100 text-blue-700",
                    call: "bg-emerald-100 text-emerald-700",
                    email: "bg-indigo-100 text-indigo-700",
                    task: "bg-amber-100 text-amber-700",
                  };
                  const typeBadge =
                    typeColors[sch.type?.toLowerCase()] ||
                    "bg-gray-100 text-gray-600";

                  return (
                    <div
                      key={i}
                      className="relative group rounded-xl border border-slate-200 bg-white/90 backdrop-blur-sm p-4 shadow-[0_1px_3px_rgba(0,0,0,0.06)] hover:shadow-lg transition-all duration-200"
                    >
                      {/* ✏️ Edit button — appears on hover only */}
                      <button
                        onClick={() => {
                          setSelectedActivity(sch);
                          setShowActivityModal(true);
                        }}
                        className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 bg-white/70 hover:bg-white text-slate-600 hover:text-slate-800 p-1 rounded-full shadow-sm transition-all"
                      >
                        <Pencil className="h-4 w-4" />
                      </button>

                      {/* Header */}
                      <div className="flex justify-between items-start">
                        <div className="space-y-1">
                          <h3 className="text-sm font-semibold text-slate-800">
                            {sch.subject}
                          </h3>

                          <div className="flex items-center gap-2 flex-wrap">
                            <span
                              className={`px-2 py-0.5 text-[11px] font-medium rounded-full capitalize ${typeBadge}`}
                            >
                              {sch.type}
                            </span>
                            <span className="text-[11px] text-gray-500">
                              Priority:{" "}
                              <span
                                className={`font-semibold ${
                                  isHigh ? "text-red-500" : "text-emerald-600"
                                }`}
                              >
                                {sch.priority}
                              </span>
                            </span>
                          </div>
                        </div>

                        <span
                          className={`px-2 py-0.5 text-[11px] font-medium rounded-full capitalize mt-1 ml-2 ${
                            isCompleted
                              ? "bg-emerald-100 text-emerald-700"
                              : isPending
                              ? "bg-amber-100 text-amber-700"
                              : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {sch.status}
                        </span>
                      </div>

                      {/* Note Section */}
                      {sch.note && (
                        <p className="mt-2 text-sm text-slate-700 border-l-2 border-emerald-400 pl-2 leading-relaxed">
                          {sch.note}
                        </p>
                      )}

                      {/* Footer */}
                      <div className="mt-3 flex flex-wrap justify-between items-center text-[12px] text-gray-500 gap-2 border-t border-slate-100 pt-2">
                        <div className="flex items-center gap-1.5">
                          <Calendar className="h-3.5 w-3.5 text-slate-400" />
                          <span>{sch.due_date}</span>
                          <Clock className="h-3.5 w-3.5 text-slate-400 ml-2" />
                          <span>{sch.due_time}</span>
                        </div>

                        <div className="flex items-center gap-1.5">
                          <User className="h-3.5 w-3.5 text-slate-400" />
                          <span className="truncate">
                            Created by <b>{sch.user?.name || "—"}</b>
                          </span>
                        </div>

                        <div className="flex items-center gap-1.5">
                          <User className="h-3.5 w-3.5 text-slate-400" />
                          <span>
                            Assigned to <b>{sch.assignee?.name || "—"}</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-gray-400 text-sm italic">
                No scheduled activities.
              </p>
            )}

            {/* ✅ Modal Integration */}
            {showActivityModal && (
              // <AddActivityModal
              //   onSubmit={onSubmit}
              //   onClose={() => setShowActivityModal(false)}
              //   onError={onError}
              //   PackageList={PackageList}
              //   CustomerData={selectedActivity}
              //   id={leadDetail.deaid}
              //   entitytype="deal"
              //   entityname={leadDetail.name}
              //   UsersList={UsersList}
              //   entityData={entityData}
              //   onSearchEntity={onSearchEntity}
              // />
              <EmployeeDirectoryAddUpdate
                onClose={() => {
                  setShowActivityModal(false);
                  setSelectedActivity(null);
                }}
                data={selectedActivity}
                tabIndex={2}
                onError={onError}
                onSubmit={onSubmit}
                id={leadDetail?.dealid}
                entitytype="deal"
                entityname={leadDetail.name}
              />
            )}
          </div>
        )}

        {activeTab === "timeline" && (
          <div className="space-y-4">
            <SectionCard title="Timeline">
              <div className="flex flex-col h-full">
                <div className="flex-1 overflow-y-auto pr-4">
                  <div className="relative ml-8">
                    {/* ✅ Single clean vertical line */}
                    <div className="absolute left-3 top-0 h-full border-l-2 border-gray-200"></div>

                    {leadDetail?.activities?.length ? (
                      leadDetail.activities.map((act, i) => {
                        const userName = act?.user?.name || "U";
                        const userInitial = userName.charAt(0).toUpperCase();
                        const colors = [
                          "bg-emerald-500",
                          "bg-blue-500",
                          "bg-indigo-500",
                          "bg-rose-500",
                        ];
                        const userColor = "bg-slate-200";

                        return (
                          <div key={i} className="relative pl-10 pb-6">
                            {/* ✅ User Initial Circle */}
                            <div
                              className={`absolute left-0 top-0 flex items-center justify-center w-7 h-7 rounded-full bg-slate-200 text-slate-700 text-xs font-semibold`}
                            >
                              {userInitial}
                            </div>

                            {/* ✅ Activity content properly aligned */}
                            <div className="flex flex-col gap-1 pt-0.5">
                              <div className="flex justify-between items-center">
                                <p className="text-sm font-medium text-gray-800">
                                  {act.log}
                                </p>
                                <p className="text-xs text-gray-400">
                                  {act.logtime}
                                </p>
                              </div>

                              {act?.user?.name && (
                                <div className="flex items-center gap-1 text-xs text-gray-500">
                                  <User className="h-3 w-3 text-gray-400" />
                                  <span className="leading-none">
                                    by {act.user.name}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-gray-400">No timeline available.</p>
                    )}
                  </div>
                </div>
              </div>
            </SectionCard>
          </div>
        )}

        {activeTab === "comments" && (
          <div className="space-y-4">
            <CommentsSection
              type="deal"
              id={leadDetail.dealid}
              apiBaseUrl="deal"
              // setAlertData={setAlertData}
            />
          </div>
        )}

        {activeTab === "files" && (
          <FilesTab
            leadId={leadDetail?.dealid}
            attachments={leadDetail?.attachments}
            attachmenttype="deal"
          />
        )}

        {activeTab === "brief" && (
          <div className="space-y-4">
            <SectionCard title="Project Brief">
              {Array.isArray(leadDetail?.briefs) &&
              leadDetail.briefs.length > 0 ? (
                <div className="divide-y divide-slate-200">
                  {leadDetail.briefs.map((item, index) => {
                    // 🧠 Replace all URLs in answer with clickable links showing clean names
                    const formattedAnswer = item.answer
                      ? item.answer.replace(/(https?:\/\/[^\s,]+)/g, (url) => {
                          try {
                            const parts = url.split("/");
                            const fileName = parts[parts.length - 1];

                            // 🧩 Check if it looks like a file link
                            const isFile = /\.[a-zA-Z0-9]{2,5}($|\?)/.test(
                              fileName
                            );

                            let displayText;
                            if (isFile) {
                              // Example: Trina-Sandell---2025Resume.pdf
                              displayText = decodeURIComponent(fileName);
                            } else {
                              // Example: linkedin.com/in/trina-sandell-2b040225
                              const domain = new URL(url).hostname.replace(
                                "www.",
                                ""
                              );
                              const path = new URL(url).pathname.replace(
                                /^\/|\/$/g,
                                ""
                              );
                              displayText = `${domain}/${path}`.slice(0, 60); // Trim long paths
                            }

                            return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">${displayText}</a>`;
                          } catch {
                            return url;
                          }
                        })
                      : "—";

                    // Add space between multiple links for readability
                    const spacedAnswer = formattedAnswer.replace(
                      /<\/a>\s*(?=<a )/g,
                      "</a> &nbsp;&nbsp;"
                    );

                    return (
                      <div key={index} className="py-4">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                          <div className="sm:w-1/3">
                            <h3 className="text-sm font-semibold text-slate-700">
                              {item.question}
                            </h3>
                          </div>
                          <div className="sm:flex-1">
                            <p
                              className="text-sm text-slate-600 leading-relaxed whitespace-pre-line break-words"
                              dangerouslySetInnerHTML={{ __html: spacedAnswer }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-gray-400 italic text-sm">
                  No brief data available.
                </p>
              )}
            </SectionCard>
          </div>
        )}
      </div>
    </div>
  );
};

const EditableField = ({
  label,
  value,
  fieldKey,
  editable = false,
  multiline = false,
  onSave, // async function (fieldKey, newValue)
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  const handleSave = async () => {
    setLoading(true);
    setError(null);
    try {
      await onSave(fieldKey, draft);
      setEditing(false);
    } catch (err) {
      console.error("Save failed", err);
      setError("Save failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setDraft(value ?? "");
    setEditing(false);
    setError(null);
  };

  return (
    <div className="relative">
      <div className="grid grid-cols-12 items-start gap-2 py-2">
        <div className="col-span-4 text-xs font-medium text-slate-500 capitalize">
          {label}
        </div>
        <div className="col-span-8 text-sm text-slate-900">
          {!editing ? (
            <div className="relative flex items-center justify-between">
              <div className="truncate">{value || "-"}</div>

              {/* icons always visible now */}
              <div className="flex-shrink-0 ml-2">
                {editable ? (
                  <button
                    className="inline-flex items-center justify-center p-1 rounded hover:bg-slate-100"
                    title="Edit"
                    onClick={() => setEditing(true)}
                    aria-label={`Edit ${label}`}
                  >
                    <Pencil className="h-4 w-4 text-slate-500" />
                  </button>
                ) : (
                  <span className="inline-flex items-center gap-1 p-1 text-xs text-gray-400">
                    <Lock className="h-4 w-4" />
                  </span>
                )}
              </div>
            </div>
          ) : (
            <div className="space-y-2">
              {multiline ? (
                <textarea
                  value={draft}
                  onChange={(e) => setDraft(e.target.value)}
                  rows={3}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-300"
                />
              ) : (
                <input
                  value={draft}
                  onChange={(e) => setDraft(e.target.value)}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-300"
                />
              )}

              <div className="flex items-center gap-2">
                <button
                  onClick={handleSave}
                  disabled={loading}
                  className="inline-flex items-center gap-2 bg-emerald-600 text-white px-3 py-1 rounded-md hover:bg-emerald-700 disabled:opacity-60"
                >
                  {loading ? (
                    "Saving..."
                  ) : (
                    <>
                      <Check className="h-4 w-4" /> Save
                    </>
                  )}
                </button>
                <button
                  onClick={handleCancel}
                  disabled={loading}
                  className="inline-flex items-center gap-2 border px-3 py-1 rounded-md hover:bg-slate-50"
                >
                  <X className="h-4 w-4" /> Cancel
                </button>
                {error && (
                  <span className="text-rose-500 text-sm ml-2">{error}</span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// FieldRow Component
// const FieldRow = ({ label, value }) => {
//   const isUrl =
//     typeof value === "string" && (value.startsWith("http://") || value.startsWith("https://"));

//   return (
//     <div className="grid grid-cols-12 items-center gap-4 py-2">
//       <div className="col-span-4 text-xs font-medium text-slate-500 capitalize">
//         {label}
//       </div>
//       <div
//         className="col-span-8 text-sm text-slate-900 truncate"
//         title={isUrl ? value : undefined} // 👈 hover tooltip full show karega
//       >
//         {isUrl ? (
//           <a
//             href={value}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-blue-600 hover:underline"
//           >
//             {value}
//           </a>
//         ) : (
//           value || "-"
//         )}
//       </div>
//     </div>
//   );
// };

const CopyIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div
        className="ms-2 hover:opacity-50 cursor-pointer transition-all"
        onClick={() => {
          copyToClipboard(text);
        }}
      >
        {isCopied ? (
          <CopyCheck size={15} color="#333" />
        ) : (
          <Copy size={15} color="#333" />
        )}
      </div>
    </>
  );
};

const FieldRow = ({
  label,
  value,
  type = "text",
  opt = [],
  keyName,
  isLock = false,
  unApprovedVal,
}) => {
  const [isActive, setIsActive] = useState(false);
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));

  return (
    <div className={`${Style.fieldRow} flex flex-col gap-[18px] w-full py-3`}>
      <div className="flex items-center justify-between">
        <div className="text-[14px] font-medium text-[#0E121B]">{label}</div>
      </div>
      <div className="w-full relative">
        {isUrl ? (
          <>
            <div className="flex justify-between text-[14px] w-full font-normal text-[#999]  border-b-[1px] pb-[16px] border-solid border-[#CACFD8] ">
              <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                className=" text-gray-500 hover:underline "
              >
                {value?.length > 100 ? `${value?.slice(0, 50)}...` : value}
              </a>

              <CopyIcon text={value} />
            </div>
          </>
        ) : (
          <input
            type="text"
            className={`text-[14px] w-full font-normal text-[#999] ${
              isActive
                ? "border-[1px] p-[10px] rounded-md"
                : "border-b-[1px] pb-[15px]"
            } border-solid border-[#CACFD8] ${
              !isActive ? "cursor-default" : ""
            }`}
            value={value}
            readOnly={!isActive}
          />
        )}
      </div>
    </div>
  );
};

// Main Component
export default function DealDetailMain() {
  const { state } = useContext(GlobalContext);
  const { id } = useParams();
  const [leadDetail, setLeadDetail] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [UsersList, setUsersList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [entityData, setEntityData] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [menuOpen, setMenuOpen] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const apiCall = useApiCall();

  const getData = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `deals/get-deal/${id}`,
      });
      setLeadDetail(res?.data);
      console.log("Deal Detail", res.data);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const editableFields = {
    name: true,
    email: true,
    phone: true,
    city: true,
    state: false,
    country: true,
    country_code: false,
    product_name: false,
  };

  useEffect(() => {
    fetchUsers();
    fetchEntities();
  }, []);

  // onSave handler - updates backend & local state (optimistic)
  const handleFieldSave = async (key, newValue) => {
    // optional: client-side validation
    // e.g. if (key === 'email' && !validateEmail(newValue)) throw new Error('Invalid email');

    // optimistic local update
    setLeadDetail((prev) => ({ ...prev, [key]: newValue }));

    try {
      const payload = { [key]: newValue };
      await apiCall({
        method: "put",
        url: `leads/update-field/${leadDetail?.dealid || id}`, // adapt endpoint
        data: payload,
      });
      // optional: show toast success
    } catch (err) {
      // rollback on error
      setLeadDetail((prev) => ({ ...prev, [key]: leadDetail?.[key] })); // resets to previous (you may persist previous to variable)
      throw err; // rethrow so EditableField shows error
    }
  };

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsersList(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchEntities = async (search = "") => {
    try {
      const res = await apiCall({
        method: "get",
        url: `activities/get-activity-type?search=${encodeURIComponent(
          search
        )}`,
      });

      const list = res?.data || []; // 👈 safe access to data array

      setEntityData(
        list.map((item) => ({
          id: item.id,
          name: item.name,
          type: item.type,
        }))
      );
    } catch (error) {
      console.error("Error fetching entities:", error);
    }
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const [showEditModal, setShowEditModal] = useState(false); //
  const [currentData, setCurrentData] = useState({}); //
  const [DealStages, setDealStages] = useState([]); //
  const [Products, setProducts] = useState([]); //
  const [Brands, setBrands] = useState([]); //
  const [country, setCountry] = useState([]); //
  const [subProducts, setSubProducts] = useState([]); //
  const [packages, setPackages] = useState([]); //
  const [PackageList, setPackageList] = useState([]);

  const [showWonModal, setShowWonModal] = useState(false);
  const [showLostModal, setShowLostModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [lostFormDeal, setLostFormDeal] = useState(null);
  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const updateSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowEditModal(false);
    setCurrentData({});
  };

  const updateError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  const DealPackage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `brands/brand-packages-list?is_paginate=0`,
      });

      setPackageList(res.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost"
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getSubProducts = async (productId) => {
    if (!productId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${productId}`,
      });
      setSubProducts(res?.data || []);
    } catch (error) {
      console.error("Error fetching sub products:", error);
    }
  };

  const getPackages = async (subProductId) => {
    if (!subProductId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const Countries = async () => {
    try {
      const res = await apiCall({ method: "get", url: `location/get-countries` });
      setCountry(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getBrands();
    getProducts();
    DealPackage();
    DealStage();
    fetchUsers();
    Countries();
  }, []);

  const editLeadDetails = () => {
    setShowEditModal(true);
    setMenuOpen(false);
    setCurrentData(leadDetail);
  };

  const handleStageChange = async (newStage) => {
    const lowerStage = newStage.toLowerCase().replace(/\s+/g, "_");
    const currentStage = leadDetail?.current_stage?.dealstatus ?? "-";

    if (lowerStage === "won") {
      setWonFormDeal(leadDetail);
      setShowWonModal(true);
      return;
    }
    if (lowerStage === "lost") {
      setLostFormDeal(leadDetail);
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${leadDetail.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: leadDetail?.dealkey, dealstatus: lowerStage },
        });
        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
        getData({}); // refresh lead detail
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error"
        );
      }
    }
  };

  return (
    <div className="flex flex-col h-full bg-slate-50 text-slate-800">
      {/* Cover & Header */}
      {/* Header Component */}
      <div className="relative">
        {/* Cover Photo */}
        <div className="relative h-48 w-full bg-gradient-to-r from-emerald-100 via-teal-100 to-sky-100 overflow-hidden">
          <img
            src={`${state?.basePath}/cover-photo.jpg`}
            alt="cover"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
        </div>

        {/* Top Right Actions */}
        <div className="absolute right-4 top-4 flex items-center gap-2 z-10">
          <a href={`tel:${leadDetail?.contact?.phone}`}>
            <IconButton title="Call">
              <PhoneCall className="h-5 w-5" />
            </IconButton>
          </a>
          <a href={`mailto:${leadDetail?.contact?.email}`}>
            <IconButton title="Email">
              <Mail className="h-5 w-5" />
            </IconButton>
          </a>
        </div>

        {/* Identity Strip / Lead Info */}
        {isLoading ? (
          <div className="mx-auto -mt-20 w-full max-w-7xl px-4">
            <div className="rounded-2xl bg-white shadow-xl border border-gray-100 p-6 animate-pulse">
              {/* Avatar + Info Skeleton */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div className="flex items-center gap-6">
                  <div className="h-24 w-24 rounded-2xl bg-gray-200" />
                  <div className="flex flex-col gap-3">
                    <div className="h-5 w-48 bg-gray-200 rounded" />
                    <div className="flex gap-3">
                      <div className="h-4 w-24 bg-gray-200 rounded" />
                      <div className="h-4 w-24 bg-gray-200 rounded" />
                    </div>
                    <div className="flex gap-4">
                      <div className="h-4 w-20 bg-gray-200 rounded" />
                      <div className="h-4 w-20 bg-gray-200 rounded" />
                      <div className="h-4 w-20 bg-gray-200 rounded" />
                    </div>
                  </div>
                </div>
                <div className="flex gap-3">
                  <div className="h-8 w-28 bg-gray-200 rounded-lg" />
                  <div className="h-8 w-28 bg-gray-200 rounded-lg" />
                </div>
              </div>

              {/* Stats Skeleton */}
              <div className="flex justify-center gap-10 border-t border-gray-100 pt-6 mt-6">
                {Array(4)
                  .fill()
                  .map((_, i) => (
                    <div key={i} className="flex flex-col items-center gap-2">
                      <div className="h-3 w-20 bg-gray-200 rounded" />
                      <div className="h-4 w-16 bg-gray-300 rounded" />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="mx-auto -mt-20 w-full max-w-7xl px-4">
            <div className="flex flex-col gap-4 rounded-2xl bg-white shadow-xl border border-gray-100 p-6 backdrop-blur-sm">
              {/* Top Section: Avatar + Info + Actions */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                {/* Left: Avatar + Info */}
                <div className="flex items-center gap-6">
                  <div className="h-24 w-24 rounded-2xl bg-gradient-to-br from-emerald-200 to-sky-200 text-white flex items-center justify-center text-3xl font-bold shadow-sm">
                    {leadDetail?.contact?.name?.[0]?.toUpperCase() || "?"}
                  </div>

                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-3 flex-wrap">
                      <h2 className="text-xl font-bold text-gray-800">
                        {leadDetail?.contactid} – {leadDetail?.contact?.name}
                      </h2>
                      {leadDetail?.current_stage?.dealstatus && (
                        <Chip
                          color={
                            {
                              Won: "green",
                              Lost: "red",
                              Proposal: "blue",
                              Review: "violet",
                            }[leadDetail.current_stage.dealstatus] || "gray"
                          }
                        >
                          {leadDetail.current_stage.dealstatus}
                        </Chip>
                      )}
                    </div>

                    <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                      <a
                        href={`tel:${leadDetail?.contact?.phone}`}
                        className="flex items-center gap-1 hover:text-emerald-600"
                      >
                        <PhoneCall className="h-4 w-4" />
                        {leadDetail?.contact?.phone || "-"}
                      </a>
                      <a
                        href={`mailto:${leadDetail?.contact?.email}`}
                        className="flex items-center gap-1 hover:text-sky-600"
                      >
                        <Mail className="h-4 w-4" />
                        {leadDetail?.contact?.email || "-"}
                      </a>
                      <span className="flex items-center gap-1">
                        <MapPin className="h-4 w-4 text-gray-400" />
                        {leadDetail?.contact?.country || "-"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right: Actions */}
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setShowActivityModal(true)}
                    className="flex items-center gap-2 rounded-lg bg-emerald-50 px-3 py-2 text-sm font-medium text-emerald-700 hover:bg-emerald-100 transition"
                  >
                    <Plus className="h-4 w-4" />
                    Add Follow-Ups
                  </button>
                  <button
                    onClick={editLeadDetails}
                    className={`flex items-center gap-2 rounded-lg bg-sky-50 px-3 py-2 text-sm font-medium text-sky-700 hover:bg-sky-100 transition ${
                      ["Won", "Lost"].includes(
                        leadDetail?.current_stage?.dealstatus
                      )
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  >
                    <SquarePen className="h-4 w-4" />
                    Edit Deal
                  </button>

                  <Tooltip content="Invoice" position="top center">
                    <button
                      onClick={() => {
                        if (leadDetail?.invoice_details) {
                          setInvoicePopup(true);
                          setInvoiceData(leadDetail?.invoice_details);
                        }
                      }}
                      className="flex items-center gap-2 rounded-lg bg-[#2563eb] px-3 py-2 text-sm font-medium text-white hover:bg-[#1e4fdb] transition"
                    >
                      <FileText className="h-4 w-4" />
                    </button>
                  </Tooltip>
                </div>
              </div>

              {/* Bottom: Stats + Stage Actions */}
            </div>
          </div>
        )}
      </div>

      {/* Tabs + Content */}

      {isLoading ? (
        <InnerLoader />
      ) : (
        <main className="flex-1 mx-auto w-full h-full max-w-7xl space-y-6 px-4">
          <div className="flex flex-col md:flex-row items-center justify-between border-t border-gray-100 p-4">
            {DealStages?.length > 0 && (
              <div className="w-full md:md:max-w-[58rem]">
                <p className="text-xs text-slate-500 mb-1 font-medium">
                  Stage Pipeline
                </p>
                <div className="flex w-full h-7 overflow-hidden rounded-md">
                  {DealStages.map((s, i) => {
                    const isWon =
                      leadDetail?.current_stage?.dealstatus === "Won";
                    const isLost =
                      leadDetail?.current_stage?.dealstatus === "Lost";
                    const isWonOrLost = isWon || isLost;
                    const currentStageIndex = DealStages.findIndex(
                      (st) => st.name === leadDetail?.current_stage?.dealstatus
                    );
                    const activeColor = isWon
                      ? "#22c55e"
                      : isLost
                      ? "#ef4444"
                      : "#2563eb";

                    const isFirst = i === 0;
                    const isLast = i === DealStages.length - 1;

                    let clipPath = "";
                    if (isFirst)
                      clipPath =
                        "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
                    else if (isLast)
                      clipPath =
                        "polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0)";
                    else
                      clipPath =
                        "polygon(0 0, 10px 50%, 0 100%, calc(100% - 10px) 100%, 100% 50%, calc(100% - 10px) 0)";

                    return (
                      <div
                        key={s.id}
                        onClick={() => {
                          if (isWonOrLost) return;
                          handleStageChange(s.name);
                        }}
                        title={s.name}
                        style={{
                          clipPath,
                          WebkitClipPath: clipPath,
                          backgroundColor:
                            i <= currentStageIndex && !isWonOrLost
                              ? activeColor
                              : "#e5e7eb",
                          transition: "background-color 0.3s ease",
                          cursor: isWonOrLost ? "not-allowed" : "pointer",
                        }}
                        className="flex-1 relative flex items-center justify-center text-[10px] font-medium text-white select-none"
                      >
                        {i <= currentStageIndex && !isWonOrLost ? (
                          <Check className="size-3" />
                        ) : (
                          s.name[0]
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Right: Stage Icons */}
            <div className="flex items-center gap-3 mt-4 md:mt-0">
              <button
                onClick={() => {
                  if (
                    ["Won", "Lost"].includes(
                      leadDetail?.current_stage?.dealstatus
                    )
                  )
                    return;
                  setWonFormDeal(leadDetail); // send full lead detail
                  setShowWonModal(true);
                }}
                title="Mark as Won"
                className={`p-2 rounded-full transition ${
                  leadDetail?.current_stage?.dealstatus === "Won"
                    ? "bg-green-500 text-white"
                    : "bg-slate-100 text-slate-500 hover:bg-green-100 hover:text-green-600"
                } ${
                  ["Won", "Lost"].includes(
                    leadDetail?.current_stage?.dealstatus
                  )
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              >
                <ThumbsUp className="size-4" />
              </button>

              <button
                onClick={() => {
                  if (
                    ["Won", "Lost"].includes(
                      leadDetail?.current_stage?.dealstatus
                    )
                  )
                    return;
                  setLostFormDeal(leadDetail);
                  setShowLostModal(true);
                }}
                title="Mark as Lost"
                className={`p-2 rounded-full transition ${
                  leadDetail?.current_stage?.dealstatus === "Lost"
                    ? "bg-rose-500 text-white"
                    : "bg-slate-100 text-slate-500 hover:bg-rose-100 hover:text-rose-600"
                } ${
                  ["Won", "Lost"].includes(
                    leadDetail?.current_stage?.dealstatus
                  )
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              >
                <ThumbsDown className="size-4" />
              </button>
            </div>
          </div>

          {/* stats */}
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mt-5">
            {isLoading
              ? Array.from({ length: 6 }).map((_, i) => (
                  <Skeleton style={{ width: "100%", height: "72px" }} key={i} />
                ))
              : leadDetail?.stats?.map((st, i) => (
                  <InfoItem
                    key={st.key || i}
                    icon={<Building2 className="h-5 w-5" />}
                    label={st.key
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                    value={st.value || "-"}
                  />
                ))}
          </div>

          <LeadTabs
            leadDetail={leadDetail}
            isLoading={isLoading}
            editableFields={editableFields}
            onSubmit={onSuccess}
            onClose={() => setShowModal(false)}
            onError={onError}
            UsersList={UsersList}
            entityData={entityData}
            onSearchEntity={fetchEntities}
            onFieldSave={handleFieldSave}
            DealStages={DealStages}
          />
        </main>
      )}

      {showActivityModal && (
        // <AddActivityModal
        //   onSubmit={onSuccess}
        //   onClose={() => setShowActivityModal(false)}
        //   onError={onError}
        //   CustomerData={null}
        //   id={leadDetail.dealid}
        //   entitytype="deal"
        //   entityname={leadDetail.name}
        //   UsersList={UsersList}
        //   entityData={entityData}
        //   onSearchEntity={fetchEntities}
        // />

        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowActivityModal(false);
          }}
          data={null}
          tabIndex={2}
          onError={onError}
          onSubmit={onSuccess}
          id={leadDetail.dealid}
          entitytype="deal"
          entityname={leadDetail.name}
        />
      )}

      {invoicePopup && invoiceData && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceData(null);
          }}
          data={invoiceData}
          type="deal"
        />
      )}

      {showEditModal && (

        <EmployeeDirectoryAddUpdate
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
          }}
          data={leadDetail}
          tabIndex={1}
          contactId={leadDetail?.contactid}
          onDealUpdated={() => setCurrentData({})} // refresh after update
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}

      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onDealUpdated={() => getData()}
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onDealUpdated={() => getData()}
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
